import React from "react";
import { ControlProps } from "react-select";
import { VisuallyHiddenElement } from "shared/styles/constants";
import { DefaultControl } from "./DefaultControl";

export const HiddenControl: React.FC<ControlProps<any, false>> = ({ children, ...props }) => (
  <VisuallyHiddenElement>
    <DefaultControl {...props}>{children}</DefaultControl>
  </VisuallyHiddenElement>
);
